import { combineEpics } from 'redux-observable';

import { AppEpic } from 'common/epics/appEpic';
import { messageEpicFactory } from 'common/epics/messageEpic';
import { navigationEpicFactory } from 'common/epics/navigationEpic';

export function rootEpicFactory(...args: AppEpic[]): AppEpic {
    return combineEpics(...args, messageEpicFactory(), navigationEpicFactory());
}
